import { render } from "./MediaBodyComponent.vue?vue&type=template&id=e808ad1c&scoped=true"
import script from "./MediaBodyComponent.vue?vue&type=script&lang=js"
export * from "./MediaBodyComponent.vue?vue&type=script&lang=js"

import "./MediaBodyComponent.vue?vue&type=style&index=0&id=e808ad1c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e808ad1c"]])

export default __exports__